module.exports = __webpack_public_path__ + "img/neigefu.14cc5a56.png";